// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"393":"e4f7fcb7","497":"40318ba8","623":"40318ba8"}[chunkId] + ".chunk.css";
};